import { createUserOnboardingDetailsQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useUserOnboardingDetailsQuery = createUserOnboardingDetailsQuery(HTTP_CONFIG.API.Consumer.url)
